module.exports = __webpack_public_path__ + "static/media/f6.3a13f6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f6.png
// module id = 1217
// module chunks = 0